/**
 * Query freshness tuning for Assigned Review Task page.
 */
export const ASSIGNED_REVIEW_TASK_WORKFLOWS_STALE_MS = 60_000;
export const ASSIGNED_REVIEW_TASK_BATCHES_STALE_MS = 60_000;
export const ASSIGNED_REVIEW_TASK_ASSIGNMENTS_STALE_MS = 15_000;

export const ASSIGNED_REVIEW_TASK_DEFAULT_PAGE_SIZE_OPTIONS = [10, 20, 40, 60];
export const ASSIGNED_REVIEW_TASK_FALLBACK_DEFAULT_PAGE_SIZE = 20;
